import React from 'react';
import {
  Form,
} from '@mairistem/composants';
import {
  LigneMouvement,
  MULTI,
  Tiers as TiersInterface,
  Rib,
  type Mouvement,
  type Exercice,
  Sens,
} from '@mairistem/comptabilite';
import { isNil, isEmpty } from 'lodash';
import BaseProfilEcritureMouvement from
  '../../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';
import { isLibelleReferenceVisible } from '../../../../constants/mouvements/modeReglements';
import getRibChanges from '../../../../utils/mouvements/rib';
import ReferencesBancaire from '../../Common/ReferencesBancaire';
import TiersInformations from '../../Common/TiersInformations';
import type PanelData from '../../../../interfaces/pieces/mouvements/panelData';
import { getDureeFromTiersOrExercice } from '../Complements/DelaiPaiement/delaiPaiementUtils';

const RIB_MULTI = {
  bic: MULTI,
  defaut: true,
  iban: '',
  identifiant: MULTI,
  identifiantTiers: 0,
  titulaire: '',
} as Rib;

interface TiersProps {
  exercice: Exercice;
  isTiersMulti: boolean;
  onChange: (ligneData: Partial<LigneMouvement>, mouvementData?: Pick<Mouvement, 'dureeDelaiGlobalPaiement'>) => void
  panelData: PanelData;
  profilEcriture: BaseProfilEcritureMouvement;
  sens: string;
  tiers: TiersInterface;
}

const Tiers = ({
  exercice,
  isTiersMulti,
  onChange,
  panelData,
  profilEcriture,
  sens,
  tiers,
}: TiersProps) => {
  const handleTiersReset = () => {
    onChange({
      identifiantTiers: null,
      modeReglement: null,
      tiers: null,
    });
  };
  const handleTiersChange = (t: TiersInterface) => {
    if (!isNil(t)) {
      const rib = t?.ribs.find((r) => r.defaut);
      onChange(
        {
          identifiantTiers: Number(t?.identifiant),
          modeReglement: t?.modeReglementDepense,
          ...(getRibChanges(rib)),
          tiers: t,
        },
        getDureeFromTiersOrExercice(exercice, t),
      );
    }
  };

  const handleChange = (e, { name, value }) => {
    onChange({ [name]: value });
  };

  const handleRibChange = (rib: Rib) => {
    // Si on n'est pas sur le rib MULTI
    if (rib?.identifiant.toString() !== MULTI) {
      onChange(getRibChanges(rib));
    }
  };

  return (
    <Form>
      <TiersInformations
        adresse={tiers?.adresses?.[0]}
        modeReglement={panelData?.modeReglement ?? ''}
        onChange={onChange}
        onReset={handleTiersReset}
        onTiersChange={handleTiersChange}
        placeholderModeReglement={panelData?.modeReglement === MULTI ? MULTI : ''}
        placeholderTiersInput={isTiersMulti ? MULTI : ''}
        profilEcriture={profilEcriture}
        sens={sens}
        tiers={tiers}
      />
      {isLibelleReferenceVisible(panelData?.modeReglement, sens as Sens) && (
        <ReferencesBancaire
          identifiantRib={panelData?.iban === MULTI
            ? MULTI
            : tiers?.ribs?.find((rib) => rib.iban === panelData?.iban)?.identifiant}
          libelleVirementZoneLibre={panelData?.libelleVirementZoneLibre}
          libelleVirementZonLibre={panelData?.libelleVirementZonLibre}
          onChange={handleChange}
          onRibChange={handleRibChange}
          ribs={[
            ...((!isTiersMulti && !isEmpty(tiers?.ribs)) ? (tiers?.ribs ?? []) : []),
            ...(panelData?.iban === MULTI ? [RIB_MULTI] : []),
          ]}
        />
      )}

    </Form>
  );
};

export default Tiers;
